// extracted by mini-css-extract-plugin
module.exports = {"container":"Instructions_container__hgIDS","instructionSecondPart":"Instructions_instructionSecondPart__nVJxg"};